import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer } from "recharts";


export const PlayerRadar = () => {
  const { number } = useParams<{ number: string }>();
  const [data, setData] = useState<any[]>([]);
  const [playerName, setPlayerName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user || !number) return;

      // Récupère tous les matchs du user
      const { data: matches } = await supabase
        .from("matches")
        .select("id")
        .eq("user_id", user.id);

      const matchIds = matches?.map((m) => m.id) || [];

      const { data: stats } = await supabase
        .from("match_stats")
        .select("*")
        .in("match_id", matchIds)
        .eq("player_number", parseInt(number));

      if (!stats || stats.length === 0) {
        setLoading(false);
        return;
      }

      const games = stats.length;
      const sum = {
        points: 0,
        assists: 0,
        rebounds: 0,
        steals: 0,
        blocks: 0,
        turnovers: 0,
      };

      stats.forEach((s) => {
        sum.points += s.points;
        sum.assists += s.assists;
        sum.rebounds += s.rebounds;
        sum.steals += s.steals;
        sum.blocks += s.blocks;
        sum.turnovers += s.turnovers;
      });

      const avg = {
        player_name: stats[0].player_name,
        games,
        points: +(sum.points / games).toFixed(1),
        assists: +(sum.assists / games).toFixed(1),
        rebounds: +(sum.rebounds / games).toFixed(1),
        steals: +(sum.steals / games).toFixed(1),
        blocks: +(sum.blocks / games).toFixed(1),
        turnovers: +(sum.turnovers / games).toFixed(1),
      };

      setPlayerName(avg.player_name);
      setData([
        { stat: "Points", value: avg.points },
        { stat: "Passes", value: avg.assists },
        { stat: "Rebonds", value: avg.rebounds },
        { stat: "Interceptions", value: avg.steals },
        { stat: "Contres", value: avg.blocks },
        { stat: "Pertes", value: avg.turnovers },
      ]);
      setLoading(false);
    };

    fetchStats();
  }, [number]);

  if (loading) return <p className="text-center mt-10 text-gray-500">Chargement...</p>;
  if (!data.length) return <p className="text-center mt-10 text-gray-500">Aucune donnée trouvée.</p>;

  return (
    <section className="p-6 max-w-3xl mx-auto min-h-screen bg-gray-50 text-center">
      <h1 className="text-2xl font-bold text-orange-500 mb-4">Radar - {playerName}</h1>
      <p className="mb-6 text-gray-600">Moyennes par match cette saison</p>
      <ResponsiveContainer width="100%" height={400}>
        <RadarChart cx="50%" cy="50%" outerRadius="80%" data={data}>
          <PolarGrid />
          <PolarAngleAxis dataKey="stat" />
          <PolarRadiusAxis angle={30} domain={[0, Math.max(...data.map(d => d.value)) + 1]} />
          <Radar name={playerName} dataKey="value" stroke="#fc7825" fill="#fc7825" fillOpacity={0.6} />
        </RadarChart>
      </ResponsiveContainer>
    </section>
  );
};
